<section class="done">
  <img src="assets/images/verify-safe-done.png" width="200" alt="seguranca" />

  <div class="done__title">
    <strong class="text-blue">Pronto!<br /> </strong>
    Nosso processo de segurança e privacidade foi concluído!
  </div>

  <p>Agora podemos garantir muito mais segurança para o seu financiamento.</p>
  <p>
    Em breve, um <strong>Agente Omni entrará em contato</strong> com você para
    continuar sua proposta.
  </p>
</section>
